import(/* webpackMode: "eager" */ "/vercel/path0/client/app/error.tsx");
